var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYellowBox = function SvgYellowBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6339 13.0276L23.5377 1.54378C25.3726 0.485406 27.6274 0.485406 29.4623 1.54378L49.3661 13.0276C49.7035 13.2212 49.6545 13.6966 49.3036 13.8644L27.1471 24.4597C26.7379 24.6554 26.2621 24.6554 25.8529 24.4597L3.69642 13.8644C3.34551 13.6966 3.29654 13.2212 3.6339 13.0276Z",
    fill: "#01cdfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4904 29.2102C28.4904 28.6325 28.8221 28.1062 29.3432 27.857L51.7543 17.1394C51.9949 17.0243 52.2803 17.1632 52.318 17.4273C52.3556 17.702 52.375 17.9807 52.375 18.2619V41.0831C52.375 43.247 51.2269 45.2447 49.3661 46.3174L29.4623 57.8013C29.0096 58.0619 28.4904 57.7004 28.4904 57.1781V29.2102Z",
    fill: "#01cdfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6568 27.857C24.1779 28.1062 24.5096 28.6325 24.5096 29.2102V57.1781C24.5096 57.7004 23.9904 58.0619 23.5377 57.8013L3.6339 46.3174C1.7731 45.2447 0.625 43.247 0.625 41.0831V18.2619C0.625 18.227 0.6253 18.1921 0.625898 18.1573C0.636913 17.5153 1.3273 17.1784 1.90657 17.4554L23.6568 27.857Z",
    fill: "#01cdfb"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/YellowBox.71a90634.svg";
export { ForwardRef as ReactComponent };